import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})


// 路由守卫
const names = ['login', 'loginPage', 'loginSuccess', 'register', 'forget', 'registerSelect', 'webchatPage', 'preview']

router.beforeEach((to: any,from) => {
  const authStore = useAuthStore()
  if(!authStore.token && !names.includes(to.name)){
    return {path: '/login'}
  }
})

export default router
